import { ref } from 'vue';

const shouldRefreshFlag = ref(false);

export function useRefresh() {
    return {
        clearRefresh,
        triggerRefresh,
        shouldRefresh
    }
}

function shouldRefresh() {
    return shouldRefreshFlag.value;
}

function triggerRefresh() {
    shouldRefreshFlag.value = true;
}

function  clearRefresh() {
    shouldRefreshFlag.value = false
}